import React from "react";
import classes from "./ButtonsArea.module.scss";

interface Interface {
  children?: any;
  className?: string;
  left?: boolean | null;
  vert?: boolean | null;
  right?: boolean | null;
  center?: boolean | null;
  spacer?: boolean | null;
  spaceAround?: boolean | null;
  rowReverse?: boolean | null;
  bigArea?: boolean | null;
  vertGo?: boolean | null;
}
const ButtonsArea = ({
  children = null,
  left = null,
  vert = null,
  className = "",
  right = null,
  center = null,
  spacer = null,
  spaceAround = null,
  rowReverse = null,
  bigArea = null,
  vertGo = null,
}: Interface) => {
  className += " " + classes.ButtonsArea;
  if (left) className += "  " + classes.Left;
  if (vert) className += "  " + classes.Vert;
  if (right) className += "  " + classes.Right;
  if (center) className += "  " + classes.Center;
  if (spacer) className += "  " + classes.Spacer;
  if (spaceAround) className += "  " + classes.SpaceAround;
  if (rowReverse) className += "  " + classes.RowReverse;
  if (bigArea) className += "  " + classes.BigArea;
  if (vertGo) className += "  " + classes.VertGo;
  return <div className={className}>{children}</div>;
};
export default ButtonsArea;
